import React from 'react'
import styles from './quote.module.css';
export const Quote = ({ testimony, name }) => {
    return (
        <div>
            <div className={styles.bubble}>
                <blockquote>
                    {testimony}
                </blockquote>
                <cite style={{ marginTop: '10px' }}> -{name}</cite> </div>
        </div>
    )
}

export default Quote


// WEBPACK FOOTER //
// ./src/components/Testimonials/quote.jsx